import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  GetAllCategories,
  getPartsByFilter,
  DelPart,
  getAppPartsByFilter,
} from "../../api";
import { Header, Button } from "../../components";
import "../../styles/viewCustomer.css";
import { useStateContext } from "../../contexts/ContextProvider";
import { Col, Container, Row } from "react-bootstrap";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import {
  showSuccessToast,
  showErrorToast,
  showInfoToast,
} from "../../components/ToastMesg";
import SelectFilter from "../../components/SelectFilter";
import DataGrid from "../../components/DataGrid";

const Parts = () => {
  const navigate = useNavigate();
  const { userPermID, companyG } = useStateContext();
  const [getcategories, setCategories] = useState([]);
  const [AllParts, setAllParts] = useState("");
  const [category, setcategory] = useState("");
  const [mode, setMode] = useState(false);
  const [Part_id, setPart_id] = useState("");
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(true);

  const handleRowSelected = (args) => setPart_id(args.data.part_id);

  const partsGrid = [
    {
      field: "category",
      headerText: "Category",
      minWidth: "140",
      width: "150",
      maxWidth: "220",
      textAlign: "left",
    },
    {
      field: "part_number",
      headerText: "Part No",
      minWidth: "125",
      width: "130",
      maxWidth: "140",
      textAlign: "left",
    },
    {
      field: "description",
      headerText: "Part Description",
      minWidth: "280",
      width: "360",
      maxWidth: "880",
      textAlign: "left",
    },
    {
      field: "total_stock",
      headerText: "Total Stk",
      minWidth: "130",
      width: "135",
      maxWidth: "140",
      textAlign: "center",
    },
    {
      field: "unit",
      headerText: "UoM",
      minWidth: "110",
      width: "120",
      maxWidth: "140",
      textAlign: "left",
    },
    {
      field: "s_category",
      headerText: "Sales Category",
      minWidth: "175",
      width: "180",
      maxWidth: "220",
      textAlign: "left",
    },
    {
      field: "stockroom_location",
      headerText: "Location",
      minWidth: "140",
      width: "180",
      maxWidth: "380",
      textAlign: "left",
    },
    {
      field: "cost_price",
      headerText: "Unit Price",
      minWidth: "140",
      width: "140",
      maxWidth: "180",
      format: "C2",
      textAlign: "right",
    },
    {
      field: "serialized_str",
      headerText: "Serialized",
      minWidth: "140",
      width: "140",
      maxWidth: "145",
      textAlign: "left",
    },
    {
      field: "pn_status",
      headerText: "Status",
      minWidth: "120",
      width: "120",
      maxWidth: "130",
      textAlign: "left",
    },
    {
      field: "pn_note",
      headerText: "PN Note",
      minWidth: "130",
      width: "140",
      maxWidth: "400",
      textAlign: "left",
    },
    {
      field: "bom_str",
      headerText: "BOM",
      minWidth: "110",
      width: "120",
      maxWidth: "120",
      textAlign: "left",
    },
    {
      field: "kit_open_count",
      headerText: "Kit Open",
      minWidth: "160",
      width: "160",
      maxWidth: "160",
      textAlign: "left",
    },
  ];

  const appPartsGrid = [
    {
      field: "category",
      headerText: "Category",
      minWidth: "140",
      width: "150",
      maxWidth: "220",
      textAlign: "left",
    },
    {
      field: "part_number",
      headerText: "Part No",
      minWidth: "125",
      width: "130",
      maxWidth: "140",
      textAlign: "left",
    },
    {
      field: "description",
      headerText: "Part Description",
      minWidth: "280",
      width: "360",
      maxWidth: "880",
      textAlign: "left",
    },
    {
      field: "pn_status",
      headerText: "Status",
      minWidth: "120",
      width: "120",
      maxWidth: "130",
      textAlign: "left",
    },
    {
      field: "stockroom_location",
      headerText: "Location",
      minWidth: "140",
      width: "180",
      maxWidth: "380",
      textAlign: "left",
    },
    {
      field: "bom_str",
      headerText: "BOM",
      minWidth: "110",
      width: "120",
      maxWidth: "120",
      textAlign: "left",
    },
    {
      field: "mfg_name1",
      headerText: "Mfg 1 Name",
      minWidth: "120",
      width: "160",
      maxWidth: "280",
      textAlign: "left",
    },
    {
      field: "mfg_pn1",
      headerText: "Mfg 1 PN",
      minWidth: "120",
      width: "160",
      maxWidth: "280",
      textAlign: "center",
    },
    {
      field: "mfg_name2",
      headerText: "Mfg 2 Name",
      minWidth: "120",
      width: "160",
      maxWidth: "280",
      textAlign: "left",
    },
    {
      field: "mfg_pn2",
      headerText: "Mfg 2 PN",
      minWidth: "120",
      width: "160",
      maxWidth: "280",
      textAlign: "center",
    },
    {
      field: "mfg_name3",
      headerText: "Mfg 3 Name",
      minWidth: "120",
      width: "160",
      maxWidth: "280",
      textAlign: "left",
    },
    {
      field: "mfg_pn3",
      headerText: "Mfg 3 PN",
      minWidth: "120",
      width: "160",
      maxWidth: "280",
      textAlign: "center",
    },
  ];

  const handleAddNewProdClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    if (
      Part_id !== "" &&
      window.confirm(`Are you sure you want to copy the selected Part?`)
    )
      localStorage.setItem("copyPart", Part_id);
    navigate("/Part/AddPart");
  };

  const handleEditPartClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    if (Part_id !== "") navigate(`/Part/EditPart/${Part_id}`);
    else showInfoToast("Info!", "Please select product to edit!");
  };

  const handleDeletePartClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      if (Part_id !== "") {
        if (
          window.confirm(`Are you sure you want to delete the selected Part?`)
        ) {
          const resp = await DelPart(Part_id);
          if (resp.success) {
            showSuccessToast("Success!", `Part deleted successfully.`);
            window.location.reload();
          } else
            showErrorToast("Error!", `Part failed to delete: ${resp.message}`);
        }
      } else showInfoToast("Info!", "Please select product to delete!");
    } catch (error) {
      showErrorToast("Error!", "Part failed to delete!");
    }
  };

  const handleViewPartClick = () => {
    TimeoutUtility.resetTimeout();
    if (Part_id !== "") navigate(`/Part/ViewPart/${Part_id}`);
    else showInfoToast("Info!", "Please select part to view!");
  };

  const handleApprPartClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    if (Part_id !== "") navigate(`/Part/ApprovedPart/${Part_id}`);
    else showInfoToast("Info!", "Please select part to view approved parts!");
  };

  const handlePartHistClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    if (Part_id !== "") navigate(`/Part/PartHistory/${Part_id}`);
    else showInfoToast("Info!", "Please select part to view Part History!");
  };

  const handlePartUsedClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    if (Part_id !== "") navigate(`/Part/PartUsed/${Part_id}`);
    else showInfoToast("Info!", "Please select part to view Part Used!");
  };

  const handleUpdateBOMClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    if (Part_id !== "") navigate(`/BOMs/AddEditBOM/${Part_id}`);
    else showInfoToast("Info!", "Please select part to view approved parts!");
  };

  const handleChangeCategory = (option) => {
    TimeoutUtility.resetTimeout();
    if (option && option.value) setcategory(option);
    else setcategory("select");
  };

  useEffect(() => {
    async function fetchData() {
      if (companyG !== null && companyG.company_id !== 0) {
        let cmp_id = companyG.company_id;
        let ctg_id = null;
        if (category !== "select" && category !== "Select Term")
          ctg_id = category.value;
        setloading(true);
        if (mode === false)
          trackPromise(
            getPartsByFilter(cmp_id, ctg_id)
              .then((productsResponse) => setAllParts(productsResponse.data))
              .catch((error) => console.error("Error fetching data:", error))
              .finally(() => setloading(false)),
          );
        else
          trackPromise(
            getAppPartsByFilter(cmp_id, ctg_id)
              .then((productsResponse) => setAllParts(productsResponse.data))
              .catch((error) => console.error("Error fetching data:", error))
              .finally(() => setloading(false)),
          );
      }
    }
    fetchData();
  }, [companyG, category, mode]);

  const handleRefresh = async () => {
    if (companyG !== null && companyG.company_id !== 0) {
      let cmp_id = companyG.company_id;
      let ctg_id = null;
      if (category !== "select" && category !== "Select Term")
        ctg_id = category.value;
      if (mode === false) {
        const resp = await getPartsByFilter(cmp_id, ctg_id);
        setAllParts(resp.data || []);
      } else {
        const resp = await getAppPartsByFilter(cmp_id, ctg_id);
        setAllParts(resp.data || []);
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      TimeoutUtility.resetTimeout();
      await GetAllCategories()
        .then((resp) => {
          const typeOptions = resp.data.map((item) => ({
            label: item.name,
            value: item.category_id,
          }));
          setCategories(typeOptions || []);
        })
        .catch((err) => console.log(err.message));
    };
    fetchData();
  }, []);

  return (
    <div>
      <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
        <Row>
          <Col xl={2} md={3}>
            <Header category="Stock" title="PARTS" />
          </Col>
          <Col xl={8} md={6} className="text-center">
            <Header title={companyG.name} />
          </Col>
          <Col xl={2} md={3}>
            <label className="font-bold mr-2 mt-3">Approved Parts View: </label>
            <input
              type="checkbox"
              name="mode"
              checked={mode}
              style={{ width: "20px", height: "20px" }}
              onChange={(args) => setMode(mode ? false : true)}
            />
          </Col>
        </Row>
        <Container fluid className="g-0 p-0 justify-end">
          <Row xs={2} className="button-row justify-content-end font-normal">
            {userPermID.includes(21) && (
              <Col md="auto p-0">
                <Button text="Add" onClick={handleAddNewProdClick} />
              </Col>
            )}
            {userPermID.includes(22) && (
              <>
                <Col md="auto p-0">
                  <Button text="Update" onClick={handleEditPartClick} />
                </Col>
                <Col md="auto p-0">
                  <Button text="Delete" onClick={handleDeletePartClick} />
                </Col>
                <Col md="auto p-0">
                  <Button text="Approved Parts" onClick={handleApprPartClick} />
                </Col>
                <Col md="auto p-0">
                  <Button text="Part History" onClick={handlePartHistClick} />
                </Col>
                <Col md="auto p-0">
                  <Button text="Part Used" onClick={handlePartUsedClick} />
                </Col>
                <Col md="auto p-0">
                  <Button text="Update BOM" onClick={handleUpdateBOMClick} />
                </Col>
              </>
            )}
            <Col md="auto p-0">
              <SelectFilter
                value={category}
                options={getcategories}
                onChange={handleChangeCategory}
                placeholder="Select Category"
              />
            </Col>
          </Row>
        </Container>
        <DataGrid
          loading={loading || promiseInProgress}
          data={AllParts}
          cols={mode ? appPartsGrid : partsGrid}
          name="part"
          handleRowSelected={handleRowSelected}
          handleDoubleClick={userPermID.includes(20) && handleViewPartClick}
          persistant={false}
          handleRefresh={handleRefresh}
        />
      </div>
    </div>
  );
};

export default Parts;
